'use strict';/*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Settings_context} from '../settings_ctx';
import styles from './coming_soon_banner.module.less';
import cn from 'classnames';

const Globe = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.5 12C22.5 17.799
        17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101
        6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM8.73256
        20.3885C7.20576 18.7332 6.15904 15.9513 6.01662 12.75H3.03081C3.31881
        16.2411 5.59934 19.1672 8.73256 20.3885ZM9.0436 18.2993C8.21215
        16.9136 7.62682 14.9735 7.51823 12.75H11.25V20.3661C10.5184
        20.1074 9.73991 19.4599 9.0436 18.2993ZM12.75 20.3661C13.4816
        20.1074 14.2601 19.4599 14.9564 18.2993C15.7878 16.9136 16.3732
        14.9735 16.4818 12.75H12.75V20.3661ZM12.75 11.25H16.4818C16.3732
        9.02649 15.7878 7.08642 14.9564 5.70068C14.2601 4.54015 13.4816
        3.89257 12.75 3.63394V11.25ZM11.25 3.63394C10.5184 3.89257 9.73991
        4.54015 9.0436 5.70068C8.21215 7.08642 7.62682 9.02649 7.51823
        11.25H11.25V3.63394ZM15.2674 20.3885C16.7942 18.7332 17.841 15.9513
        17.9834 12.75H20.9692C20.6812 16.2411 18.4007 19.1672 15.2674
        20.3885ZM17.9834 11.25H20.9692C20.6812 7.75891 18.4007 4.8328
        15.2674 3.61148C16.7942 5.26684 17.841 8.04868 17.9834
        11.25ZM3.03081 11.25H6.01662C6.15904 8.04868 7.20576 5.26684
        8.73255 3.61148C5.59933 4.8328 3.31881 7.75891 3.03081 11.25Z"
        fill="#71BBFF"/>
    </svg>;
};

const Speed = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_107_5207)">
      <path d="M21.4814 12C21.4814 6.76365 17.2364 2.51855 12
        2.51855C6.76365 2.51855 2.51855 6.76365 2.51855 12C2.51855 17.2364
        6.76365 21.4814 12 21.4814C17.2364 21.4814 21.4814 17.2364 21.4814
        12ZM4.05664 12C4.05664 7.61279 7.61279 4.05664 12 4.05664C12.4781
        4.05664 12.9474 4.09838 13.4033 4.17969C13.821 4.25434 14.0988
        4.65351 14.0244 5.07129C13.9499 5.48926 13.5508 5.76789 13.1328
        5.69336C12.7657 5.6279 12.3871 5.59375 12 5.59375C8.46193 5.59375
        5.59375 8.46193 5.59375 12C5.59375 13.362 6.01772 14.6228 6.74121
        15.6602C6.98411 16.0084 6.89901 16.4876 6.55078 16.7305C6.2026
        16.9733 5.72339 16.8881 5.48047 16.54C4.58275 15.253 4.05664 13.6867
        4.05664 12ZM18.4062 12C18.4062 11.5277 18.3552 11.0678 18.2588
        10.626C18.1685 10.2114 18.4311 9.80151 18.8457 9.71094C19.2605
        9.62037 19.6702 9.88403 19.7607 10.2988C19.8805 10.8476 19.9434
        11.4169 19.9434 12C19.9434 13.6867 19.4172 15.253 18.5195
        16.54C18.2766 16.8881 17.7974 16.9733 17.4492 16.7305C17.101
        16.4876 17.0159 16.0084 17.2588 15.6602C17.9823 14.6228 18.4062
        13.362 18.4062 12ZM16.0684 6.84375C16.3686 6.54353 16.856 6.54353
        17.1562 6.84375C17.4563 7.14386 17.4561 7.63044 17.1562
        7.93066L13.6875 11.3994C13.7544 11.5875 13.7939 11.789 13.7939
        12C13.7939 12.9907 12.9907 13.7939 12 13.7939C11.0093 13.7939
        10.2061 12.9907 10.2061 12C10.2061 11.0093 11.0093 10.2061 12
        10.2061C12.2106 10.2061 12.4119 10.2449 12.5996 10.3115L16.0684
        6.84375ZM23.0186 12C23.0186 18.0855 18.0855 23.0186 12
        23.0186C5.91451 23.0186 0.981445 18.0855 0.981445 12C0.981445
        5.91451 5.91451 0.981445 12 0.981445C18.0855 0.981445 23.0186
        5.91451 23.0186 12Z" fill="#FFB9F8"/>
      </g>
      <defs>
      <clipPath id="clip0_107_5207">
      <rect width="24" height="24" fill="white"/>
      </clipPath>
      </defs>
    </svg>;
};

const Gift = ()=>{
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M16.5 1.25C17.362
        1.25 18.1884 1.59266 18.7979 2.20215C19.4073 2.81164 19.75 3.63805
        19.75 4.5C19.75 5.1259 19.5677 5.732 19.2354 6.25098C19.5945
        6.25237 19.9068 6.2574 20.1748 6.2793C20.5545 6.31033 20.9109
        6.3781 21.2481 6.5498C21.7655 6.81346 22.1865 7.23451 22.4502
        7.75195C22.6219 8.08909 22.6897 8.44547 22.7207 8.8252C22.751
        9.19632 22.75 9.65252 22.75 10.2002V18.7998C22.75 19.3475 22.751
        19.8037 22.7207 20.1748C22.6897 20.5545 22.6219 20.9109 22.4502
        21.248C22.1865 21.7655 21.7655 22.1865 21.2481 22.4502C20.9109
        22.6219 20.5545 22.6897 20.1748 22.7207C19.8037 22.751 19.3475
        22.75 18.7998 22.75H5.2002C4.65253 22.75 4.19633 22.751 3.8252
        22.7207C3.44547 22.6897 3.0891 22.6219 2.75196 22.4502C2.23451
        22.1865 1.81346 21.7655 1.54981 21.248C1.3781 20.9109 1.31033
        20.5545 1.2793 20.1748C1.24898 19.8037 1.25 19.3475 1.25
        18.7998V10.2002C1.25 9.65252 1.24898 9.19632 1.2793 8.8252C1.31033
        8.44546 1.3781 8.08909 1.54981 7.75195C1.81346 7.23451 2.23451
        6.81346 2.75196 6.5498C3.0891 6.37809 3.44547 6.31033 3.8252
        6.2793C4.09294 6.25742 4.40497 6.25238 4.76368 6.25098C4.43153
        5.7321 4.25 5.12572 4.25 4.5C4.25 3.63805 4.59266 2.81164 5.20215
        2.20215C5.81164 1.59266 6.63805 1.25 7.5 1.25C9.66708 1.25 10.9883
        2.80885 11.7197 4.13867C11.8228 4.32599 11.9149 4.51351 12
        4.69629C12.0851 4.51351 12.1773 4.32599 12.2803 4.13867C13.0117
        2.80885 14.3329 1.25 16.5 1.25ZM2.75 18.7998C2.75 19.3722 2.75024
        19.7569 2.77442 20.0527C2.79788 20.3397 2.84059 20.4768 2.88672
        20.5674C3.00655 20.8025 3.19751 20.9935 3.43262 21.1133C3.52316
        21.1594 3.66028 21.2021 3.94727 21.2256C4.24315 21.2498 4.62778
        21.25 5.2002 21.25H11.25V14.75H2.75V18.7998ZM12.75
        21.25H18.7998C19.3722 21.25 19.7569 21.2498 20.0527
        21.2256C20.3397 21.2021 20.4768 21.1594 20.5674 21.1133C20.8025
        20.9935 20.9935 20.8025 21.1133 20.5674C21.1594 20.4768 21.2021
        20.3397 21.2256 20.0527C21.2498 19.7569 21.25 19.3722 21.25
        18.7998V14.75H12.75V21.25ZM5.2002 7.75C4.62778 7.75 4.24315
        7.75024 3.94727 7.77441C3.66028 7.79788 3.52316 7.84059 3.43262
        7.88672C3.19751 8.00655 3.00655 8.1975 2.88672 8.43262C2.84059
        8.52316 2.79788 8.66027 2.77442 8.94727C2.75024 9.24314 2.75
        9.62777 2.75 10.2002V13.25H11.25V7.75H5.2002ZM12.75
        13.25H21.25V10.2002C21.25 9.62777 21.2498 9.24314 21.2256
        8.94727C21.2021 8.66027 21.1594 8.52316 21.1133 8.43262C20.9935
        8.19751 20.8025 8.00654 20.5674 7.88672C20.4768 7.84059 20.3397
        7.79787 20.0527 7.77441C19.7569 7.75024 19.3722 7.75 18.7998
        7.75H12.75V13.25ZM7.5 2.75C7.03588 2.75 6.59089 2.93451 6.2627
        3.2627C5.93451 3.59088 5.75 4.03587 5.75 4.5C5.75 4.96413 5.93451
        5.40912 6.2627 5.7373C6.59089 6.06549 7.03588 6.25 7.5
        6.25H11.0078C10.8694 5.84315 10.6737 5.3493 10.4053
        4.86133C9.76168 3.6912 8.83289 2.75 7.5 2.75ZM16.5 2.75C15.1671
        2.75 14.2383 3.6912 13.5947 4.86133C13.3263 5.3493 13.1306 5.84315
        12.9922 6.25H16.5C16.9641 6.25 17.4091 6.06549 17.7373
        5.7373C18.0655 5.40912 18.25 4.96413 18.25 4.5C18.25 4.03587
        18.0655 3.59088 17.7373 3.2627C17.4091 2.93451 16.9641 2.75 16.5
        2.75Z" fill="#FFA800"/>
    </svg>;
};

const cards = [
    {
      icon: Globe,
      title: 'Geo Location Control',
      desc: 'Select a region to connect through when gaming with friends'
            +' overseas or when accessing various servers.',
      cls: 'blue'
    },
    {
      icon: Speed,
      title: 'Speed Test',
      desc: 'Run quick network diagnostics to measure ping, packet loss,'
            +' and connection stability.',
      cls: 'pink'
    },
    {
      icon: Gift,
      title: 'Game Bargain Finder',
      desc: 'Discover deals and discounts for popular games and gaming'
            +' platforms in one place.',
      cls: 'yellow'
    },
];

interface i_coming_soon_banner_props {
    title: string;
}

export const Coming_soon_banner = (props: i_coming_soon_banner_props)=>{
    const {title} = props;
    const {theme} = useContext(Settings_context);
    return <div className={styles.wrapper}>
      <h2 className={styles.header}>{title}</h2>
      <div className={styles.cards}>
        {cards.map(c=>
          <div key={c.title} className={`${styles.card} ${styles[c.cls]}`}>
            <c.icon />
            <div className={styles.card_text}>
              <p className={cn([theme.p2_med, theme.color_n700, theme.med])}>
                {c.title}</p>
              <p className={cn([theme.p3, theme.color_n600])}>{c.desc}</p>
            </div>
          </div>
        )}
      </div>
      <p className={cn([styles.footer, theme.p4, theme.med,
        theme.color_n600])}>
        Suggested apps or features? We would love to hear from you!&nbsp;
        <a href="mailto:help@hola.org">help@hola.org</a>
      </p>
    </div>;
};

interface i_coming_soon_banner_editor_props {
    value: i_coming_soon_banner_props;
    on_change: (new_val: i_coming_soon_banner_props)=>void;
}

export const Coming_soon_banner_editor = (
{value, on_change}: i_coming_soon_banner_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h2)', type: 'text'},
      ]}/>;
};
